import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, Renderer2 } from '@angular/core'
import { DomSanitizer } from '@angular/platform-browser'
import { Subscription } from 'rxjs'
import { ApiService } from '../api.service'
import Swal from 'sweetalert2'

@Component({
	selector: 'multimedia',
	templateUrl: './multimedia.component.html',
	styleUrls: ['./multimedia.component.scss']
})

export class MultimediaComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {

	@Input() courseID = 0
	@Input() parentType = 'lesson'
	@Input() parentID = 0
	@Input() dialog = false
	lessonID = 0

	loading = true
	hasMultimedia = false
	clipboard: Clipboard | undefined
	
	upload = false
	download = false
	uploadImages: any[] = []
	uploadVideos: any[] = []
	uploading = false
	uploadSuccess = false
	uploadError = false
	
	images: any[] = []
	videos: any[] = []
	imagesSize = 0
	videosSize = 0
	multimediaTotalSize = 0
	
	// audio = false

	getLessonMultimediaSub = new Subscription
	fileUploadSub = new Subscription
	editMultimediaSub = new Subscription
	deleteMultimediaItemSub = new Subscription
	downloadMultimediaSub = new Subscription
	audioUploadSub = new Subscription

	bytesToMB = 1048576
	sizeLimitBytes = 33554432 // 32 MB

	@Output() onClose: EventEmitter<boolean> = new EventEmitter

	constructor(private dataService: ApiService, private renderer: Renderer2, private sanitizer: DomSanitizer) { }

	ngOnInit(): void {
		// this.loading = true
		this.clipboard = navigator.clipboard
	}

	ngAfterViewInit(): void {}

	ngOnChanges(): void {
		console.log(this.parentType)
		console.log(this.parentID)
		if (this.parentType == 'lesson') {
			this.lessonID = this.parentID
			this.getLessonMultimedia(this.lessonID)
		}
	}

	ngOnDestroy(): void {
		this.getLessonMultimediaSub?.unsubscribe()
	}

	close() {
		this.onClose.emit(true)
	}

	getLessonMultimedia(lesson: number) {
		this.images = []
		this.videos = []

		this.getLessonMultimediaSub = this.dataService.getLessonMultimedia(this.courseID, lesson)
		.subscribe(
			data => {
				// console.log(data)
				this.loading = false
				this.images = data.images
				this.videos = data.videos
				this.hasMultimedia = this.images.length > 0 || this.videos.length > 0

				this.images.forEach((image: any) => {
					// Align
					image.align = 'right'

					// Ref
					this.updateMultimediaRef(image)

					image.altSaved = false
					image.sourceSaved = false
					image.refCopied = false

					// Size
					this.imagesSize += +image.filesize
				})
				
				this.videos.forEach((video: any) => {
					console.log(video)
					// Align
					video.align = 'right'
					
					// Ref
					this.updateMultimediaRef(video)

					// File
					if (video.file != null) {
						// video.fileUrl = `${this.dataService.baseUrl}/media/${this.site}/vid/${this.courseID}/${video.file}`
						// video.fileUrl = `http://35.181.121.25:8889/motoria-angular/media/${this.site}/vid/${this.courseID}/${video.file}`
						
						// video.safeFileUrl = this.sanitizer.sanitize(SecurityContext.HTML, video.fileUrl)
						// video.safeFileUrl = this.sanitizer.sanitize(SecurityContext.RESOURCE_URL, video.fileUrl)
						video.safeFileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(video.url)
						// video.safeFileUrl = this.sanitizer.sanitize(SecurityContext.URL, this.sanitizer.bypassSecurityTrustUrl(video.fileUrl))
					} 
					// URL
					else if (video.url != null) {
						// video.safeUrl = this.sanitizer.sanitize(SecurityContext.URL, video.url)
						video.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(video.url)
						// video.safeUrlStr = this.sanitizer.bypassSecurityTrustUrl(video.url)
						// video.safeUrlStr = this.sanitizer.sanitize(SecurityContext.HTML, video.url)
						// video.safeUrlStr = this.sanitizer.sanitize(SecurityContext.HTML, this.sanitizer.bypassSecurityTrustHtml(video.url))
					}

					video.altSaved = false
					video.sourceSaved = false
					video.refCopied = false

					// Size
					this.videosSize += +video.filesize
				})

				// console.log(this.images)
				// console.log(this.videos)

				this.multimediaTotalSize = +((this.imagesSize + this.videosSize) / this.bytesToMB).toFixed(2)
				this.imagesSize = +(this.imagesSize / this.bytesToMB).toFixed(2)
				this.videosSize = +(this.videosSize / this.bytesToMB).toFixed(2)
			},
			_error => {
				// console.log(error)
				this.images = []
				this.videos = []
				this.hasMultimedia = false
			},
		)
	}

	addFileToList(event: Event) {
		let input = event.currentTarget as HTMLInputElement
		let files: any = input.files
		// console.log(files)

		let filesSkipped = false
		for (let f = 0; f < files.length; f++) {
			let file = files.item(f)
			file.sizeMB = (file.size / this.bytesToMB).toFixed(2)
			if (file.size >= this.sizeLimitBytes) {
				filesSkipped = true
				continue
			}
			let type = file.type.split('/')[0]
			// console.log(file)
			// console.log(type)

			if (type !== 'image' && type !== 'video') {
				Swal.fire('Error', 'El archivo que ha subido no es un archivo multimedia (imagen / video). Por favor, suba un archivo multimedia válido.', 'error')
			}

			if (type === 'image') {
				if (this.uploadImages.includes(file)) {
					Swal.fire('Error', 'Ya se ha subido este archivo.', 'error')
				} else {
					this.uploadImages?.push(file)
				}
			} else if (type === 'video') {
				if (this.uploadVideos.includes(file)) {
					Swal.fire('Error', 'Ya se ha subido este archivo.', 'error')
				} else {
					this.uploadVideos?.push(file)
				}
			}
		}

		this.renderer.setProperty(input, 'value', '')

		if (filesSkipped) {
			Swal.fire('Cuidado', 'Uno o más archivos pesan más de 32 MB, no se añadirán a la lista.', 'warning')
		}
	}

	removeFileFromList(file: File) {
		let type = file.type.split('/')[0]
		let list
		if (type === 'image') list = this.uploadImages
		else if (type === 'video') list = this.uploadVideos
		list?.splice(list.indexOf(file), 1)
	}

	uploadMultimediaFiles() {
		// console.log(this.uploadImages)
		// console.log(this.uploadVideos)

		let uploadedFiles = 0
		let totalFiles = this.uploadImages.length + this.uploadVideos.length
		this.uploading = true
		this.uploadError = false
		this.uploadSuccess = false

		this.uploadImages.forEach((file) => {
			this.fileUploadSub = this.dataService.uploadMultimedia(this.courseID, this.lessonID, 'image', file)
			.subscribe(
				data => {
					// console.log(data)
					if (data.toString().length > 0) {
						uploadedFiles++
					}
					
					if (uploadedFiles === totalFiles) {
						this.uploading = false
						this.uploadError = false
						this.uploadSuccess = true
						this.uploadImages = []
						this.uploadVideos = []
					}
				},
				_error => {
					// console.log(error)
					this.uploading = false
					this.uploadError = true
					this.uploadSuccess = false
				}
			)
			// this.fileUploadSub.unsubscribe()
		})

		this.uploadVideos.forEach((file) => {
			this.fileUploadSub = this.dataService.uploadMultimedia(this.courseID, this.lessonID, 'video', file)
			.subscribe(
				data => {
					// console.log(data)
					if (data.toString().length > 0) {
						uploadedFiles++
					}
					
					if (uploadedFiles === totalFiles) {
						this.uploading = false
						this.uploadError = false
						this.uploadSuccess = true
						this.uploadImages = []
						this.uploadVideos = []
					}
				},
				_error => {
					// console.log(error)
					this.uploading = false
					this.uploadError = true
					this.uploadSuccess = false
				}
			)
			// this.fileUploadSub.unsubscribe()
		})
	}

	downloadMultimedia(course: number, lesson: number, type: 'all' | 'image' | 'video' = 'all') {
		this.downloadMultimediaSub = this.dataService.downloadMultimedia(course, lesson, type)
		.subscribe(
			(file: any) => {
				let filename = `multimedia_${course}_${type}.zip`
				let blob = new Blob([file.body], { type: file.body.type })
				let url = URL.createObjectURL(blob)

				let link = document.createElement('a')
				link.href = url
				link.download = filename
				link.click()
				link.remove()
				URL.revokeObjectURL(url)
			},
			_error => {
				// console.log(error)
			},
		)
	}

	audioUpload(id: number, event: any) {
		// this.audio = false
		let audioFile = event.currentTarget.files.item(0)
		// console.log(audioFile)
		
		this.audioUploadSub = this.dataService.uploadAudio(this.courseID, 'multimedia', id, audioFile)
		.subscribe(
			_newAudio => {
				// console.log(newAudio)
				// this.audio = true
				this.getLessonMultimedia(this.lessonID)
			},
			error => {
				console.log(error)
			},
		)
	}

	changeProp(image: any) {
		image.prop = !image.prop
		// console.log(image.prop)
		return false
	}

	changeWidthHeight(mult: any, input: 'width' | 'height') {
		if (mult.prop) {
			if (input == 'width') {
				mult.height = Math.floor(mult.width * mult.ratio)
			} else if (input == 'height') {
				mult.width = Math.floor(mult.height / mult.ratio)
			}
		}

		this.updateMultimediaRef(mult)
	}

	uploadSubtitlesClick(event: Event) {
		// console.log(event)
		let btn = event.currentTarget as HTMLButtonElement
		// console.log(btn)
		let fileInput = btn.previousElementSibling as HTMLInputElement
		fileInput.click()
	}

	uploadSubtitles(event: Event) {
		// console.log(event)
		let input = event.currentTarget as HTMLInputElement
		let file = input.files?.item(0)!
		let textarea = input.previousElementSibling as HTMLTextAreaElement
		// console.log(file)

		let reader = new FileReader()
		reader.onload = event => {
			let text = event.target?.result?.toString().trim() ?? ""
			textarea.value = text
		}
		reader.readAsText(file)
	}

	saveSubtitles(event: Event, videoID: number) {
		// console.log(event)
		let saveBtn = event.currentTarget as HTMLButtonElement
		let textarea = saveBtn.previousElementSibling?.previousElementSibling?.previousElementSibling as HTMLTextAreaElement
		let subtitlesText = textarea.value ?? ""
		// console.log(subtitlesText)

		this.editMultimediaSub = this.dataService.editMultimedia(videoID, 'subtitles', subtitlesText)
		.subscribe(
			_data => {
				// console.log(data)
			},
			_error => {
				// console.log(error)
			}
		)

		return false
	}

	editMultimedia(mult: any, field: string) {
		console.log(mult)
		let id = mult.id
		let value = ''
		if (field == 'alt') value = mult.alt
		else if (field == 'source') value = mult.source

		this.editMultimediaSub = this.dataService.editMultimedia(id, field, value)
		.subscribe(
			_data => {
				// console.log(data)
				if (field == 'alt') mult.altSaved = true
				else if (field == 'source') mult.sourceSaved = true
				setTimeout(() => {
					if (field == 'alt') mult.altSaved = false
					else if (field == 'source') mult.sourceSaved = false
				}, 1500)
			},
			_error => {
				// console.log(error)
			}
		)

		return false
	}

	updateMultimediaRef(mult: any) {
		let type = ''
		if (mult.type == 'image') type = 'IMG'
		else if (mult.type == 'video') type = 'VID'
		mult.ref = `[${type}#${this.courseID}#${mult.id}#${mult.width}#${mult.height}`
		if (mult.align != 'none') mult.ref += `#${mult.align}`
		mult.ref += ']'
	}
	
	copyMultimediaRef(mult: any) {
		if (!this.clipboard) return false

		navigator.clipboard.writeText(mult.ref)
		mult.refCopied = true
		setTimeout(() => {
			mult.refCopied = false
		}, 1500)

		return false
	}

	deleteMultimediaItem(mult: any) {
		let id = mult.id
		let lesson = mult.lesson
		// console.log(id)
		// console.log(lesson)

		Swal.fire({
			title: '¿Seguro?',
			text: '¿Está seguro que desea eliminar este elemento multimedia?',
			icon: 'question',
			showCancelButton: true,
			cancelButtonText: 'Cancelar'
		}).then((result) => {
			// console.log(result)
			if (!result.isConfirmed) return
			
			this.deleteMultimediaItemSub = this.dataService.deleteMultimediaItem(id)
			.subscribe(
				_data => {
					// console.log(data)
					this.getLessonMultimedia(lesson)
				},
				_error => {
					// console.log(error)
				},
			)
		})

		return false
	}

	open(url: string) {
		window.open(url)
		return false
	}

}
